import { render, staticRenderFns } from "./CreateUserControl.vue?vue&type=template&id=53d827f3&"
import script from "./CreateUserControl.vue?vue&type=script&lang=js&"
export * from "./CreateUserControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports